export default __webpack_public_path__ + "static/broschuere-studienkreis-254864e224a0ac9a0aa153b39d78575b.jpg";